export const setAllAttributes = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_ALL_ATTRIBUTES", payload: value });
  };
};

export const setUserName = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_USERNAME", payload: value });
  };
};

export const setTopThreeReports = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SIDEBAR_TOP_THREE_REPORTS", payload: value });
  };
};
export const setTemporaryWords = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_TEMPORARY_WORDS", payload: value });
  };
};
export const setReachRefreshTime = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_REACH_REFRESH_TIME", payload: value });
  };
};
